import { Pipe, PipeTransform } from '@angular/core';
import { Student } from '../models/student';
import { StudentVisit } from '../models/student-visit';
import { CourseEnrollment } from '../models/course-enrollment';

@Pipe({ name: 'name' })
export class NamePipe implements PipeTransform {
  transform(student: Student | StudentVisit | CourseEnrollment): string {
    return `${student.firstname || ''} ${student.lastname || ''}`.trim();
  }
}
